import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { HubFeature } from '@ats/api/cm';

const pathStart = 'System Settings|Tagging Domains|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Tagging,
	portal: 'SP',
};

export type SPTaggingDomainsLocNames =
	| 'SPTaggingDomainsTitlePage'
	| 'SPTaggingDomainsTitleSection'
	| 'SPTaggingDomainsTitleTab'
	| 'SPTaggingDomainsButtonAddDomain'
	| 'SPTaggingDomainsLabelName'
	| 'SPTaggingDomainsLabelItemCount';

export const spTaggingDomainsLocs: LocDefs<SPTaggingDomainsLocNames> = {
	SPTaggingDomainsTitlePage: {
		defaultValue: 'Tagging',
		description: 'Page title.',
		displayPath: `${pathStart}Page Title`,
		displayType: 'Title',
		// legacyName: 'Tagging/SystemSettings.Tagging.Title.Tagging',
		...sharedProperties,
	},
	SPTaggingDomainsTitleSection: {
		defaultValue: 'Domains',
		description: 'Section title.',
		displayPath: `${pathStart}Section Title`,
		displayType: 'Title',
		// legacyName: 'Tagging/SystemSettings.Tagging.Domains.Title.Domains',
		...sharedProperties,
	},
	SPTaggingDomainsTitleTab: {
		defaultValue: 'Tagging',
		description: 'Tab title.',
		displayPath: `${pathStart}Tab Title`,
		displayType: 'Title',
		// legacyName: 'Tagging/SystemSettings.Tagging.TabTitle.Tagging',
		...sharedProperties,
	},
	SPTaggingDomainsButtonAddDomain: {
		defaultValue: 'Add Domain',
		description: 'Add domain button.',
		displayPath: `${pathStart}Add Domain`,
		displayType: 'Button',
		// legacyName: 'Tagging/SystemSettings.Tagging.Domains.Button.AddDomain',
		...sharedProperties,
	},
	SPTaggingDomainsLabelName: {
		defaultValue: 'Name',
		description: 'Name label.',
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		// legacyName: 'Tagging/SystemSettings.Tagging.Domains.ColumnHeading.Name',
		...sharedProperties,
	},
	SPTaggingDomainsLabelItemCount: {
		defaultValue: 'No. of Tags',
		description: 'No. of Tags label.',
		displayPath: `${pathStart}No. of Tags`,
		displayType: 'Label',
		// legacyName: 'Tagging/SystemSettings.Tagging.Domains.ColumnHeading.ItemCount',
		...sharedProperties,
	},
};

export type SPTaggingDomainLocType = LocMap<SPTaggingDomainsLocNames>;
